import React from "react"
import { Box } from "@carrotfertility/carotene-core"
import icnHelpSrc from "./assets/images/icn-help.png"
import icnHelp2xSrc from "./assets/images/icn-help-2x.png"

export const HelpGlyph = () => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      borderRadius={(theme) => theme.tokens.borderRadius.round}
      sx={{ blockSize: 40, inlineSize: 40, backgroundColor: "#eee" }}
    >
      <img src={icnHelpSrc} srcSet={`${icnHelp2xSrc} 2x`} alt="" height={24} width={24} />
    </Box>
  )
}
